// extracted by mini-css-extract-plugin
export default {"customCol":"customCol---jeCiE","ownerIdField":"ownerIdField---VfA7F"};